import "./App.css";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import HomePage from "./Pages/HomePage";
import LoginPage from "./Pages/LoginPage";
import ActivatePage from "./Pages/ActivatePage";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/*" element={<HomePage />} />
          <Route exact path="/login" element={<LoginPage />} />
          {/* <Route exact path="/activate/:token" element={<ActivatePage />} /> */}
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
